export default __webpack_public_path__ + "static/media/tourism.b63afbd0.svg";